import React, { useState, useEffect } from 'react';
import AnimatedCheckmark from './AnimatedCheckmark';

export default function RegtriggeringAnimatedCheckmark(props) {
  const [lastValue, setLastValue] = useState(props.animationTriggerValue);
  const [visible, setVisible] = useState(true);
  const [didChange, setDidChange] = useState(false);

  useEffect(() => {
    if (
      props.animationTriggerValue &&
      lastValue &&
      lastValue !== props.animationTriggerValue
    ) {
      setLastValue(props.animationTriggerValue);
      setVisible(false);
      setDidChange(true);
      setTimeout(() => setVisible(true), 0);
    }
  }, [props.animationTriggerValue]); // eslint-disable-line react-hooks/exhaustive-deps

  return visible ? <AnimatedCheckmark {...props} animate={didChange} /> : null;
}
